import React from 'react';

const HelpPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default HelpPage;
